module.exports = __webpack_public_path__ + "media/images/icon__point--text-6507c7db3be5951dc6d52b5edd503ae8.png";